import React from "react";
import PropTypes from "prop-types";

import { NavLink } from "react-router-dom";

import {
  _LinkContainer as LinkContainer,
  _Content as LinkContent,
  _StepIcon as Icon,
  _StepNumber as Number,
} from "./style";

export const BreadCrumbItem = ({ link, text, step, icon, isEnabled }) => {
  return (
    <LinkContainer
      data-id={`BreadCrumbItem_${step}`}
      className={`${isEnabled ? "enabled" : "disabled"}`}
    >
      <NavLink 
        to={link}
      >
        <LinkContent>
          <Number>{step}.</Number>
          <Icon src={icon} />
          <span>{text}</span>
        </LinkContent>
      </NavLink>
    </LinkContainer>
  );
};

BreadCrumbItem.propTypes = {
  link: PropTypes.string,
  text: PropTypes.string,
  step: PropTypes.string,
  icon: PropTypes.string,
  isEnabled: PropTypes.bool,
  isCurrent: PropTypes.array,
  step: PropTypes.string,
  icon: PropTypes.string,
};
